<div class="confirm_modal">
  <div class="modal-header">
    <h5 class="modal-title pull-left">
      <strong>{{ title | translate }}</strong>
    </h5>
    <button
      type="button"
      class="btn-close close pull-right"
      aria-label="Close"
      (click)="modalRef.hide()"
    >
      <img src="../../../../../assets/img/modal_cancel.svg" />
    </button>
  </div>
  <div class="modal-body pb-0">
    <p class="text-center">{{ confirmText | translate }}</p>
    <div class="row">
      <div class="col-md-12 btn_section mt-4 mb-3">
        <button
          class="bordered--btn modal-btn btn-light text-capitalize w-96 p-0 justify-content-center mr-30 mr-3"
          (click)="choice(true)"
        >
          {{ acceptButtonText | translate }}
        </button>
        <button
          *ngIf="cancleButtonText"
          class="light_bg_btn bordered--btn modal-btn text-capitalize w-96 p-0 justify-content-center"
          (click)="choice(false)"
        >
          {{ cancleButtonText | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
